import { useCallback } from "react";
const useResetPassword = (authImplementation) => {
  return useCallback(
    async (options) => {
      if (authImplementation.resetPassword) {
        return await authImplementation.resetPassword(options);
      } else {
        throw new Error(
          `Auth client ${authImplementation.type} does not implement this function`
        );
      }
    },
    [authImplementation]
  );
};
export {
  useResetPassword
};
